module.exports = __webpack_public_path__ + "static/media/fruits_51.d21b9bcb.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/fruits/fruits_51.csv
// module id = 719
// module chunks = 0